/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import ContractorAPI from '../api/contractor.js';

export const contractors = {
    state: {
        contractors: [],
        contractorsLoadStatus: 0,

        contractorAdded: {},
        contractorAddStatus: 0,

        contractorUpdated: {},
        contractorUpdateStatus: 0,

        contractorDeleted: {},
        contractorDeleteStatus: 0,
        contractorDeleteText: '',
    },

    actions: {
        loadContractors({commit}) {
            return new Promise((resolve, reject) => {
                commit('setContractorsLoadStatus', 1);

                ContractorAPI.getContractors()
                    .then(response => {
                        commit('setContractors', response.data.data);
                        commit('setContractorsLoadStatus', 2);
                        resolve();
                    })
                    .catch(() => {
                        commit('setContractors', []);
                        commit('setContractorsLoadStatus', 3);
                        reject();
                    });
            });
        },
        addContractor({commit, dispatch}, data){
            return new Promise((resolve, reject) => {
                commit('setContractorAddStatus', 1);

                ContractorAPI.postContractor( data )
                    .then(response => {
                        commit('setContractorAdded', response.data.data);
                        commit('setContractorAddStatus', 2);
                        dispatch('loadContractors');
                        resolve();
                    })
                    .catch(() => {
                        commit('setContractorAdded', []);
                        commit('setContractorAddStatus', 3);
                        reject();
                    });
            });
        },
        updateContractor({commit, dispatch}, data){
            return new Promise((resolve, reject) => {
                commit('setContractorUpdateStatus', 1);

                ContractorAPI.putContractor( data )
                    .then(response => {
                        commit('setContractorUpdateStatus', 2);
                        dispatch('loadContractors');
                        resolve();
                    })
                    .catch(() => {
                        commit('setContractorUpdateStatus', 3);
                        reject();
                    });
            });
        },
        deleteContractor({commit, dispatch}, contractorId){
            return new Promise((resolve, reject) => {
                commit('setContractorDeleteStatus', 1);

                ContractorAPI.deleteContractor( contractorId )
                    .then(response => {
                        commit('setContractorDeletedText', 'success');
                        commit('setContractorDeleteStatus', 2);
                        dispatch('loadContractors');
                        resolve();
                    })
                    .catch(() => {
                        commit('setContractorDeletedText', 'unsuccess');
                        commit('setContractorDeleteStatus', 3);
                        reject();
                    });
            });
        },
    },

    mutations: {
        setContractors( state, rawContractors ){
            state.contractors = rawContractors.map(rawContractor => {
                return {
                    id: rawContractor.id,
                    name: rawContractor.name,
                }
            });
        },
        setContractorsLoadStatus( state, status ){
            state.contractorsLoadStatus = status;
        },
        setContractorAdded( state, rawContractorAdded ){
            state.contractorAdded = rawContractorAdded;
        },
        setContractorAddStatus( state, status ){
            state.contractorAddStatus = status;
        },
        setContractorUpdated( state, rawContractorUpdated ){
            state.contractorUpdated = rawContractorUpdated;
        },
        setContractorUpdateStatus( state, status ){
            state.contractorUpdateStatus = status;
        },
        setContractorDeletedText( state, text ){
            state.contractorDeleteText = text;
        },
        setContractorDeleteStatus( state, status ){
            state.contractorDeletedStatus = status;
        },
    },

    getters: {
        getContractors(state) {
            return state.contractors;
        },
        getContractorsLoadStatus(state) {
            return state.contractorsLoadStatus;
        },
        getContractorUpdateStatus(state) {
            return state.contractorUpdateStatus;
        },
        getContractorDeleteStatus(state) {
            return state.contractorDeleteStatus;
        },
        getContractorAddStatus(state) {
            return state.contractorAddStatus;
        },
    },
};

/**
 * Helpers
 */

